import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store/index.js';
import routes from '@/router/routes/index.js';
// import { TokenService } from '@/services/Storage.Service.js';

Vue.use(VueRouter);

// const role =
//   TokenService.getUser() !== null
//     ? TokenService.getUser().accountAccountGroupId
//     : '';
const router = new VueRouter({
  mode: 'history',
  linkExactActiveClass: 'active',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: { name: '404' }
    }
  ].concat(routes)
});

router.beforeEach((to, from, next) => {
  const authenticated = store.getters.isLoggedIn;
  const onlyLoggedOut = to.matched.some((record) => record.meta.onlyLoggedOut);
  const isPublic = to.matched.some((record) => record.meta.public);
  if (!isPublic && !authenticated) {
    return next({
      path: '/login'
    });
  }
  if (authenticated && onlyLoggedOut) {
    return next('/menu');
  }
  document.title = `Monsta | ${to.meta.title}`;
  next();
});

export default router;
